import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { fetchCourses } from './actions';
import CourseListPage from './CourseListPage';
import Course from './Course';
import Loading from '../common/components/Loading';

class Courses extends Component {
  componentDidMount() {
    const { dispatch, coursesLoaded } = this.props;

    if (!coursesLoaded) {
      dispatch(fetchCourses());
    }
  }
  render() {
    const { match, coursesLoaded } = this.props;

    if (!coursesLoaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={CourseListPage} />
        <Route path={`${match.path}/:courseId`} component={Course} />
        <Redirect to={`${match.path}`} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    coursesLoaded: state.courses.courses.get('loaded'),
  };
};

export default connect(mapStateToProps)(Courses);



// WEBPACK FOOTER //
// ./src/courses/Courses.js